import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { showToast } from '../helper/notifications'; // UPDATED IMPORT
import { useAuth } from '../context/AuthContext';
import '../custom.css';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const SignInPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const signInDivRef = useRef(null);
  const initializedRef = useRef(false);

  const handleCallbackResponse = useCallback(
    async (response) => {
      if (!response?.credential) {
        // UPDATED: Use showToast for error
        showToast('error', 'Google Sign-In failed.');
        return;
      }

      try {
        const success = await login(response.credential);
        if (success) {
          // UPDATED: Use showToast for success
          showToast('success', 'Welcome back!');
          navigate("/locations-top");
        } else {
          // UPDATED: Use showToast for error
          showToast('error', 'Sign-In failed. Please try again.');
        }
      } catch (error) {
        console.error('Sign-in error:', error);
        // UPDATED: Use showToast for error
        showToast('error', 'An unexpected error occurred.');
      }
    },
    [login, navigate]
  );

  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 10;

    const renderButton = () => {
      if (initializedRef.current) return;

      if (!window.google || !signInDivRef.current) {
        if (attempts++ < maxAttempts) {
          setTimeout(renderButton, 250);
        } else {
          // UPDATED: Use showToast for error
          showToast('error', 'Google Sign-In failed to load.');
        }
        return;
      }

      const { width } = signInDivRef.current.getBoundingClientRect();
      if (width === 0) {
        requestAnimationFrame(renderButton);
        return;
      }

      try {
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: handleCallbackResponse,
        });

        window.google.accounts.id.renderButton(signInDivRef.current, {
          theme: 'outline',
          size: 'large',
          width: width, 
          text: 'signin_with',
          shape: 'rectangular',
        });

        initializedRef.current = true;
      } catch (error) {
        console.error('Google Sign-In render error:', error);
      }
    };

    renderButton();
  }, [handleCallbackResponse]);

  return (
    <div
      className="signin-page-wrapper"
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8f9fa',
        padding: '1rem'
      }}
    >
      <div 
        className="card border-0 shadow-lg rounded-4" 
        style={{ width: '100%', maxWidth: '400px' }}
      >
        <div className="card-body p-5 text-center">
          <div className="mb-4">
            <img
              src="/assets/images/logo-start.png"
              alt="Qiu One Logo"
              className="img-fluid"
              style={{ height: '140px', width: 'auto', objectFit: 'contain' }}
            />
          </div>

          <h4 className="fw-bold mb-2"></h4>
          <p className="text-muted mb-4">Please log in with your Google Account</p>

          <div className="d-flex justify-content-center mb-4" style={{ minHeight: '44px' }}>
            <div
              ref={signInDivRef}
              style={{ width: '100%' }} 
            />
          </div>

          <div className="border-top pt-3 mt-4">
            <small className="text-muted d-block">
              &copy; 2026 Qiu AI GmbH
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;